import { Dispatch } from 'redux';
import types from 'redux/actions/actionTypes';
import { axiosV2 } from 'interceptors/axios';

import { TradingOffer } from 'types';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';
import { ApiQueryParams } from 'types/ApiQueryParams';
import { updateSocietyData } from '../../society/redux/updateSocietyData';

type GetTradingOffersProps = {
  societyId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

type TradingOfferApiAddResponse = {
  tradingOffer: TradingOffer;
  tradingOffersCount: {
    buy: number;
    sell: number;
    total: number;
  };
};

type TradingOfferApiGetAllResponse = {
  data: TradingOffer[];
  total: number;
};

export const addTradingOffer =
  (tradingOfferData: Partial<TradingOffer>) => async (dispatch: Dispatch) => {
    try {
      const body = { ...tradingOfferData };
      const { data } = await axiosV2.post('/tradingOffers', body);
      const decodedData = (await decryptResponse(
        data
      )) as TradingOfferApiAddResponse;

      dispatch({
        type: types.CREATE_TRADING_OFFER,
        tradingOffer: decodedData?.tradingOffer,
      });

      updateSocietyData(decodedData, dispatch);
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const getTradingOffers =
  ({ societyId, params = {}, signal }: GetTradingOffersProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/tradingOffers', {
        params: {
          societyId,
          ...params,
        },
        // signal,
      });

      const decodedData = (await decryptResponse(
        data
      )) as TradingOfferApiGetAllResponse;

      dispatch({
        type: types.GET_TRADING_OFFERS,
        tradingOffers: decodedData.data,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const getTradingOffer =
  (operationId: string, params?: ApiQueryParams) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/tradingOffers/${operationId}`, {
        params,
      });
      const decodedData = (await decryptResponse(data)) as TradingOffer;

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
